import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { map, switchMap,  } from 'rxjs/operators';
import { MetaService } from '@ngx-meta/core';
import { ApiService } from '../_services/api.service';
import { LocalizeRouterService } from 'localize-router';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';


@Injectable()
export class DettaglioSchedaResolver implements Resolve<any> {

  constructor(
    private meta: MetaService,
    private apiService: ApiService,
    private localize: LocalizeRouterService,
    private translate: TranslateService,
    private router: Router) {}

    // responseMock = `{"enabled":false,"readOnly":false,"idScheda":1,"cdLingua":"FR","titolo":"GP-380-SX","sottotitolo":"test_sottotitolo","descrizioneBreve":"test_descrizione_breve","descrizioneLunga":"test_descrizione","dataInizioValidita":"29/10/2020","dataFineValidita":"29/10/2021","infoCommerciali":{"PREZZO_INSTALLAZIONE":{"chiave":"PREZZO_INSTALLAZIONE","descrizione":"Prix ​​d'installation","valore":"50","titolo":"Prezzo Installazione"},"PREZZO_SPEDIZIONE":{"chiave":"PREZZO_SPEDIZIONE","descrizione":"Prix ​​d'expédition","valore":"60","titolo":"Prezzo Spedizione"},"PREZZO_PROMO":{"chiave":"PREZZO_PROMO","descrizione":"Prix promo","valore":"100","titolo":"Prezzo promo"},"FLAG_NON_DISPONIBILE":{"chiave":"FLAG_NON_DISPONIBILE","descrizione":"Indisponible","valore":null,"titolo":"Non disponibile"},"RECENSIONI":{"chiave":"RECENSIONI","descrizione":"Commentaires","valore":"test","titolo":"Recensioni"},"FLAG_INSTALLAZIONE":{"chiave":"FLAG_INSTALLAZIONE","descrizione":"Installation","valore":"true","titolo":"Installazione"},"PREZZO":{"chiave":"PREZZO","descrizione":"Prix","valore":"500","titolo":"Prezzo"},"FLAG_SPEDIZIONE":{"chiave":"FLAG_SPEDIZIONE","descrizione":"Expédition","valore":"true","titolo":"Spedizione"}},"infoTecniche":{"SPESSORE":{"chiave":"SPESSORE","descrizione":"Epaisseur","valore":"20","titolo":"Spessore"},"PORTATA":{"chiave":"PORTATA","descrizione":"Portee","valore":"10","titolo":"Portata"},"PESO":{"chiave":"PESO","descrizione":"Poids","valore":"40","titolo":"Peso"},"DIMENSIONI":{"chiave":"DIMENSIONI","descrizione":"Dimension","valore":"30","titolo":"Dimensioni"}},"seo":{"FR":{"slug":"380-sx","title":"GP-380-SX","noFollow":false,"description":null,"keywords":null,"redirectUrl":null,"noIndex":false,"cdLingua":"FR"}},"correlati":[{"idCorrelato":2,"titolo":"GP-360-SX","seo":{"slug":"360-sx","title":"GP-360-SX","noFollow":false}}]}`;

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const cdLingua = this.translate.currentLang.toUpperCase();
    const slug = route.params.slug;
    console.log( 'DettaglioSchedaResolver -> ', this.translate.currentLang, ', ', route.params.slug );
    const anteprima = (route.queryParams.anteprima === 'true' ? true : false);
    const staffaTelaio = route.queryParams.staffaTelaio;
    const staffaPortiera = route.queryParams.staffaPortiera;
    const idPercorso = route.queryParams.idPercorso;

    return this.apiService.schedaGetScheda({cdLingua, slug, anteprima}).pipe(
      map(scheda => {
        console.log('dentro resolver, slug:', slug, scheda.sottocategorie[0]);
        if (!scheda) { this.router.navigate([this.localize.translateRoute('/404')]); }
        if (
          scheda.categorie[0].seo.slug !== route.params.categoriaScheda ||
          scheda.sottocategorie[0].seo.slug !==  route.params.sottocategoria ||
          scheda.seo[cdLingua].slug !== route.params.slug) {
          const base = this.localize.translateRoute('/');
          if (scheda.categorie[0] && scheda.categorie[0].seo && scheda.sottocategorie[0] && scheda.sottocategorie[0].seo && scheda.seo[cdLingua]) {
            this.router.navigate([base, scheda.categorie[0].seo.slug, scheda.sottocategorie[0].seo.slug, scheda.seo[cdLingua].slug]);
          } else {
            console.log( 'DettaglioSchedaResolver ERROR -> Non posso redirigere perché manca uno degli slug di categoria sottocategoria o scheda' );
          }
        }
        if (!scheda) { this.router.navigate([this.localize.translateRoute('/')]); }
        if (scheda.seo) {
          if (scheda.seo[cdLingua].title) {
            this.meta.setTitle(scheda.seo[cdLingua].title);
          }
          if (scheda.seo[cdLingua].description) {
            this.meta.setTag('description', scheda.seo[cdLingua].description);
          }
          if (scheda.seo[cdLingua].keywords) {
            this.meta.setTag('keywords', scheda.seo[cdLingua].keywords);
          }
          if (scheda.seo[cdLingua].noIndex) {
            this.meta.setTag('robots', 'noindex');
          }
        }
        return scheda;
      }),
      switchMap( (scheda) => {
        if (staffaTelaio && staffaTelaio !== 'null') {
          return this.apiService.schedaGetScheda({idConfiguratore: staffaTelaio, cdLingua}).pipe( map( schedaStaffaTelaio => {
            schedaStaffaTelaio.daVerificare = (schedaStaffaTelaio.titolo === 'XXXX');
            scheda.staffaTelaio = schedaStaffaTelaio;
            scheda.idPercorso = idPercorso;
            return scheda;
          }));
        } else {
          return of(scheda);
        }
      }),
      switchMap( (scheda) => {
        if (staffaPortiera && staffaPortiera !== 'null') {
          return this.apiService.schedaGetScheda({idConfiguratore: staffaPortiera, cdLingua}).pipe( map( schedaStaffaPortiera => {
            schedaStaffaPortiera.daVerificare = (schedaStaffaPortiera.titolo === 'XXXX');
            scheda.staffaPortiera = schedaStaffaPortiera;
            return scheda;
          }));
        } else {
          return of(scheda);
        }
      })
  );
  }
}


